export const southAsianCodes = [
  'IN',
  'LK',
  'NP',
  'BD',
  'MV',
  'TH',
  'LA',
  'MY',
  'MM',
  'AF',
  'PK',
  'BT',
  'SG',
]

export const southAsianNationalities = [
  'Afghan',
  'Bangladeshi',
  'Bhutanese',
  'Indian',
  'Lao, Laotian',
  'Malaysian',
  'Maldivian',
  'Burmese',
  'Nepali, Nepalese',
  'Pakistani',
  'Singaporean',
  'Sri Lankan',
  'Thai',
]
